// removed by extract-text-webpack-plugin
module.exports = {"shadow":"_5XGL-zd4OjYLuLMGA35bM","container":"_2dDK1urnRUpPBoLSPz1sgt","closeIcon":"UlqkMftsRLrDhTFuf7Knx","active":"_3DHvdnuujmu2nNEmnR0nmX","menu":"z7U9BtvpMNmKypTtqAdPF","menuTitle":"_1ZIOVg4-N5K3nB4ROARNDo","link":"_3oGHdZkxPUsJV2yy4QK9_r"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Signature/styles.css
// module id = 2558
// module chunks = 0